import axiosInstance from './axiosInstance';

export const createLog = (logData) =>
    axiosInstance.post("/Log/CreateLog", logData);
